import { configureStore, UnknownAction, ThunkAction } from "@reduxjs/toolkit";
import newRootReducer from "./rootReducer";
import rootReducer from "./rootReducer";
import type { RootState } from "./rootReducer";
const store = configureStore({
  reducer: rootReducer,
});

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./rootReducer", () => {
    // const newRootReducer = require("./rootReducer").default;
    store.replaceReducer(newRootReducer);
  });
}

export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, undefined, UnknownAction>;

export default store;
